import * as types from "./actionTypes";

export const get = data => {
  return {
    type: types.PREMIUM_INIT_REQUEST,
    data
  };
};

export const getSuccess = data => {
  return {
    type: types.PREMIUM_INIT_SUCCESS,
    payLoad: data
  };
};

export const getFailure = error => {
  return {
    type: types.PREMIUM_INIT_FAILURE,
    error: error
  };
};

export const calculatePrice = (data, transition, buyGift) => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_REQUEST,
    data,
    transition,
    buyGift
  };
};

export const calculatePriceSuccess = data => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_SUCCESS,
    payLoad: data
  };
};

export const calculatePriceFailure = error => {
  return {
    type: types.PREMIUM_CALCULATE_PRICE_FAILURE,
    error: error
  };
};

export const buyGift = data => {
  return {
    type: types.PREMIUM_BUY_GIFT_REQUEST,
    data: data
  };
};
export const buyGiftSuccess = () => {
  return {
    type: types.PREMIUM_BUY_GIFT_SUCCESS
  };
};
export const buyGiftFailure = () => {
  return {
    type: types.PREMIUM_BUY_GIFT_FAILURE
  };
};

export const useWallet = data => {
  return {
    type: types.PREMIUM_USE_WALLET_REQUEST,
    data
  };
};

export const useWalletSuccess = data => {
  return {
    type: types.PREMIUM_USE_WALLET_SUCCESS,
    payLoad: data
  };
};

export const useWalletFailure = () => {
  return {
    type: types.PREMIUM_USE_WALLET_FAILURE
  };
};

export const usePromoCode = data => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_REQUEST,
    data
  };
};

export const usePromoCodeSuccess = data => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_SUCCESS,
    payLoad: data
  };
};

export const usePromoCodeFailure = () => {
  return {
    type: types.PREMIUM_USE_PROMO_CODE_FAILURE
  };
};

export const savePremiumInfoInCash = data => {
  return {
    type: types.PREMIUM_INFO_SAVE_IN_CASH,
    data
  };
};

export const getList = pageNumber => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_REQUEST,
    pageNumber
  };
};

export const getListSuccess = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_SUCCESS,
    data: data
  };
};

export const getListFailure = error => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_FAILURE,
    error: error
  };
};

export const getListByProject = () => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST
  };
};

export const getListByProjectSuccess = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS,
    payLoad: data
  };
};

export const getListByProjectFailure = data => {
  return {
    type: types.PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE,
    payLoad: data
  };
};

export const payStore = data => {
  return {
    type: types.PREMIUM_PAY_REQUEST,
    data
  };
};

export const payStoreSuccess = data => {
  return {
    type: types.PREMIUM_PAY_SUCCESS,
    data
  };
};

export const payStoreFailure = () => {
  return {
    type: types.PREMIUM_PAY_FAILURE
  };
};

export const getPromoCode = () => {
  return {
    type: types.PREMIUM_PROMO_CODE_REQUEST
  };
};
export const getPromoCodeSuccess = data => {
  return {
    type: types.PREMIUM_PROMO_CODE_SUCCESS,
    data: data
  };
};
export const getPromoCodeFailure = error => {
  return {
    type: types.PREMIUM_PROMO_CODE_FAILURE,
    error: error
  };
};

export const getActivePlans = ownerId => {
  return {
    type: types.PREMIUM_ACTIVE_PLANS_REQUEST,
    ownerId
  };
};
export const getActivePlansSuccess = data => {
  return {
    type: types.PREMIUM_ACTIVE_PLANS_SUCCESS,
    data: data
  };
};
export const getActivePlansFailure = error => {
  return {
    type: types.PREMIUM_ACTIVE_PLANS_FAILURE,
    error: error
  };
};

export const getPremiumTransactionRequest = id => {
  return {
    type: types.PREMIUM_TRANSACTION_ITEM_REQUEST,
    id
  };
};
export const getPremiumTransactionSuccess = data => {
  return {
    type: types.PREMIUM_TRANSACTION_ITEM_SUCCESS,
    payLoad: data
  };
};
export const getPremiumTransactionFailure = error => {
  return {
    type: types.PREMIUM_TRANSACTION_ITEM_FAILURE,
    error: error
  };
};